import React, { useCallback, useEffect } from 'react';
import { ChooseProduct, ChooseProductStages, withPublicClient } from '@nakedplatform/business';
import { StorageType, Store } from '@nakedplatform/support';

import { navigation } from 'modules/navigation';
import { Routes } from 'routes';

import * as QuoteConstants from '../../quote/constants';
/**
 * Renders multi product screen
 */
function Component() {
  const stage = new URLSearchParams(window.location.search).get('stage');
  const storage = Store.getStorage(StorageType.LocalStorage);
  const updateOtherStageHistory = !Object.values(ChooseProductStages).includes(stage);

  const setFromMultiCta = useCallback(() => {
    Store.setItems(storage, { [QuoteConstants.FROM_MULTI_CTA_KEY]: 'true' });
  }, [storage]);

  const goToCar = useCallback(() => {
    setFromMultiCta();
    navigation.gotoRoute(Routes.QuoteCar);
  }, [setFromMultiCta]);

  const goToHomeContents = useCallback(() => {
    setFromMultiCta();
    navigation.gotoRoute(Routes.QuoteHousehold);
  }, [setFromMultiCta]);

  const goToTowable = useCallback(() => {
    setFromMultiCta();
    navigation.gotoRoute(Routes.QuoteTowable);
  }, [setFromMultiCta]);

  const goToBuilding = useCallback(() => {
    setFromMultiCta();
    navigation.gotoRoute(Routes.QuoteBuilding);
  }, [setFromMultiCta]);

  const goToMain = useCallback(() => {
    navigation.gotoRoute(Routes.MULTI_CTA);
  }, []);

  const goToSingleItem = useCallback(() => {
    navigation.gotoRoute(Routes.QuoteSingleItemUnderwritten);
  }, []);

  const goToPet = useCallback(() => {
    setFromMultiCta();
    navigation.gotoRoute(Routes.QuotePet);
  }, [setFromMultiCta]);

  useEnforceStageHistory({
    url: Routes.MULTI_CTA,
    shouldUpdate: updateOtherStageHistory,
  });

  return (
    <ChooseProduct
      goToMain={goToMain}
      stage={stage}
      goToCar={goToCar}
      goToHomeContents={goToHomeContents}
      goToSingleItem={goToSingleItem}
      goToBuilding={goToBuilding}
      goToTowable={goToTowable}
      goToPet={goToPet}
      showPetQuoteCta={true}
    />
  );
}
/**
 * Useful for enforcing the correct stage history url
 *
 * @param params - Stage history enforcer params
 */
function useEnforceStageHistory(params: Params) {
  const { shouldUpdate, url } = params;

  useEffect(() => {
    if (shouldUpdate) {
      /**
       * Before taking the user to the correct stage, this makes it so the history entry for the
       * current page is set to the correct stage's URL. This way, the user can't go back to the invalid URL
       * using their browser's back button or the chat back button.
       */
      window.history.replaceState(window.history.state, '', url);

      navigation.gotoRoute(url);
    }
  }, [shouldUpdate, url]);
}
/** Type definitions */
interface Params {
  /** URL to be enforced */
  url: string;
  /** If true, the correct state will be enforced */
  shouldUpdate: boolean;
}

export const ChooseProductPageContents = withPublicClient(Component);
